/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;

// TODO: Need to replace phone number with the config variable
const RemoveRecipient = (props) => {
    const {
        isReadyState,
        AddressId,
        addressType,
        currentPage,
        recipient,
        recipientsByPage,
        handleCloseModal,
        handleSubmitRemoveRecipient,
    } = props;
    const firstName = recipient.FirstName || recipient.firstname;
    const lastName = recipient.LastName || recipient.lastname;
    return (
        <>
            <p>
                This recipient will be permanently removed from your Address
                Book.
            </p>

            <div className="margin-top-2x align-center">
                <Button
                    onClick={() => handleSubmitRemoveRecipient(
                        recipient.AddressBookEntryId,
                        AddressId,
                        recipient,
                        addressType,
                        currentPage,
                        recipientsByPage,
                    )}
                    variant="contained"
                    color="primary"
                    className="remove-recipient-btn buttonHD margin-bottom-2x"
                >
                    {isReadyState
                        ? `Delete ${firstName} ${lastName}`
                        : 'Deleting...'}
                </Button>
                <Button
                    onClick={() => handleCloseModal()}
                    variant="contained"
                    className="do-not-remove-btn buttonHDSecondary"
                >
                    Don&apos;t delete
                </Button>
            </div>
        </>
    );
};

RemoveRecipient.defaultProps = {
    AddressId: -1,
    currentPage: -1,
    recipientsByPage: [],
};

RemoveRecipient.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    AddressId: PropTypes.number,
    currentPage: PropTypes.number,
    addressType: PropTypes.string.isRequired,
    recipient: PropTypes.object.isRequired,
    recipientsByPage: PropTypes.array,
    handleCloseModal: PropTypes.func.isRequired,
    handleSubmitRemoveRecipient: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('RemoveRecipient - newState', newState);
    return {
        isReadyState: newState.isReadyState,
        AddressId: newState.AddressId,
        recipient: newState.recipient,
        addressType: newState.addressType,
        currentPage: newState.giftList.currentPage,
        recipientsByPage: newState.giftList.recipientsByPage,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
    handleSubmitRemoveRecipient: (AddressBookEntryId, AddressId, recipient, addressType, currentPage, recipientsByPage) => dispatch(EventDispatcher.handleSubmitRemoveRecipient(
        AddressBookEntryId,
        AddressId,
        recipient,
        addressType,
        currentPage,
        recipientsByPage,
    )),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveRecipient);
